//
//
//
//
//
//
//
//
//
//
//

var timer = null
import MHeader from '../Header/Header.vue';
import Api from '@/utils/api';
export default {
    components: {
        MHeader
    },
    data() {
        return {
            location: null,
            openInBrowser: false,
            safari: true
        }
    },
    methods: {
    },
    mounted() {
        var that = this
        if (!this.$route.query.payingOrderId) {
            that.$store.commit('updateToast', {
                show: true,
                text: '订单信息错误'
            });
            that.$router.replace({
                name: 'orderList'
            })
            return
        }
        if (this.$route.query.payMethod == 'alipay') {
            Api.alipay(this.$route.query.payingOrderId)
            .then((resp) => {
                if (resp && resp.data) {
                    if (resp.data.alipayUrl) {
                        if (navigator.userAgent.match('MicroMessenger')) {
                            this.openInBrowser = true
                            if (navigator.userAgent.match('Mac OS')) {
                                this.safari = true
                            } else {
                                this.safari = false
                            }
                            timer = setInterval(function () {
                                if (!that.$route.query.payingOrderId) {
                                    clearInterval(timer)
                                    return
                                }
                                Api.alipay(that.$route.query.payingOrderId)
                                    .then((resp) => {
                                        if (resp && resp.data && resp.data.status && resp.data.status != 'unpaid') {
                                            that.$store.commit('updateToast', {
                                                show: true,
                                                text: '支付成功'
                                            });
                                            clearInterval(timer)
                                            setTimeout(function() {
                                                that.$router.replace({
                                                    name: 'orderList',
                                                    pathName: 'all'
                                                });
                                            }, 1000)
                                        }
                                    })
                            }, 5000)
                        } else {
                            location.href = resp.data.alipayUrl
                        }
                    } else {
                        that.$store.commit('updateToast', {
                            show: true,
                            text: '订单已支付'
                        });
                        setTimeout(function() {
                            that.$router.replace({
                                name: 'orderList',
                                pathName: 'all'
                            });
                        }, 1000)
                    }
                }
            })
        } else {
            Api.wxh5pay(this.$route.query.payingOrderId)
                .then((resp) => {
                    if (resp && resp.data) {
                        if (resp.data.return_code == 'SUCCESS') {
                            if (navigator.userAgent.match('MicroMessenger')) {
                                this.openInBrowser = true
                                if (navigator.userAgent.match('Mac OS')) {
                                    this.safari = true
                                } else {
                                    this.safari = false
                                }
                                timer = setInterval(function () {
                                    if (!that.$route.query.payingOrderId) {
                                        clearInterval(timer)
                                        return
                                    }
                                    Api.wxh5pay(that.$route.query.payingOrderId)
                                        .then((resp) => {
                                            if (resp && resp.data && resp.data.status && resp.data.status != 'unpaid') {
                                                that.$store.commit('updateToast', {
                                                    show: true,
                                                    text: '支付成功'
                                                });
                                                clearInterval(timer)
                                                setTimeout(function() {
                                                    that.$router.replace({
                                                        name: 'orderList',
                                                        pathName: 'all'
                                                    });
                                                }, 1000)
                                            }
                                        })
                                }, 5000)
                            } else if (resp.data.payable){
                                that.location = location.href
                            } else {
                                location.href = resp.data.mweb_url
                            }
                        } else {
                            that.$store.commit('updateToast', {
                                show: true,
                                text: '订单已支付'
                            });
                            setTimeout(function() {
                                that.$router.replace({
                                    name: 'orderList',
                                    pathName: 'all'
                                });
                            }, 1000)
                        }
                    }
                })
        }
    },
    destroyed(){
        if (timer) {
            clearInterval(timer)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Pay/Pay.vue